import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '../../utils/cn';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
  children: React.ReactNode;
}
export function Button({
  className,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  children,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-md font-bold transition-all duration-500 ease-out focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 focus:ring-offset-black disabled:opacity-50 disabled:pointer-events-none';
  const variants = {
    primary: 'bg-primary text-white hover:bg-primary-dark shadow-[0_0_15px_rgba(232,76,26,0.4)] hover:shadow-[0_0_25px_rgba(232,76,26,0.6)] border border-transparent',
    outline: 'bg-transparent text-white border-2 border-primary hover:bg-primary/10 hover:shadow-[0_0_15px_rgba(232,76,26,0.2)]',
    ghost: 'bg-transparent text-white hover:text-primary hover:bg-white/5'
  };
  const sizes = {
    sm: 'h-9 px-4 text-sm',
    md: 'h-11 px-6 text-base',
    lg: 'h-14 px-8 text-lg'
  };
  return <motion.button whileHover={{
    scale: 1.02,
    translateY: -1
  }} whileTap={{
    scale: 0.98,
    translateY: 0
  }} transition={{
    duration: 0.2,
    ease: 'easeOut'
  }} className={cn(baseStyles, variants[variant], sizes[size], fullWidth ? 'w-full' : '', className)} {...props as any} data-id="element-561">
      {children}
    </motion.button>;
}